export interface BrowserInfo {
  readonly devicePixelRatio: number;
  readonly screenHeight: number;
  readonly screenWidth: number;
  readonly clientHeight: number;
  readonly clientWidth: number;
  readonly isExecutingInIFrame: boolean;
}

export const getDisplayMode = (): string => {
  if (window.matchMedia('(display-mode: fullscreen)').matches) {
    return 'fullscreen';
  }

  if (window.matchMedia('(display-mode: standalone)').matches) {
    return 'standalone';
  }

  if (window.matchMedia('(display-mode: minimal-ui)').matches) {
    return 'minimal-ui';
  }

  return 'browser';
};

export type GetBrowserInfo = () => BrowserInfo;
export const getBrowserInfo: GetBrowserInfo = () => ({
  devicePixelRatio: window.devicePixelRatio,
  screenHeight: window.screen.height,
  screenWidth: window.screen.width,
  clientHeight: window.document.documentElement.clientHeight,
  clientWidth: window.document.documentElement.clientWidth,
  displayMode: getDisplayMode(),
  notificationPermission: 'Notification' in window ? Notification.permission : undefined,
  isExecutingInIFrame: window.top !== window.self,
});
